import {
    Component,
    AfterViewInit,
    OnDestroy,
    ChangeDetectorRef,
    OnInit,
    ViewChild,
    EventEmitter,
    ViewContainerRef,
    ComponentFactoryResolver
} from '@angular/core';
import { get, merge } from 'lodash';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

import { IWizardEntry } from '../../wizard.entry';
import { WizardComponent } from '../../wizard.component';
import { LdapServerConfigurationComponent } from './ldap.server.configuration/ldap.server.configuration.component';
import { LdapServerResultComponent } from './ldap.server.result/ldap.server.result.component';
import { LdapConfigWizardService } from '../../services/ldap-servers/ldap.server.service';

@Component({
    selector: 'ldap-configuration-wizard',
    providers: [LdapConfigWizardService],
    templateUrl: '../../wizard.template.html',
    styleUrls: ['../../wizard.component.style.scss', '../../wizard.button.style.scss', './ldap.server.configuration/ldap.server.configuration.component.scss']
})
export class LdapServerWizardComponent
    extends WizardComponent
    implements OnInit, AfterViewInit, OnDestroy, IWizardEntry {
    @ViewChild('contentPlaceholder', { read: ViewContainerRef, static: true })
    contentRef: ViewContainerRef;
    @ViewChild('subContentPlaceholder', { read: ViewContainerRef, static: true })
    subContentRef: ViewContainerRef;

    wizardConfig: any; // eslint-disable-line
    wizardId: string;
    dataId: any; // eslint-disable-line
    onClose = new EventEmitter<any>(); // eslint-disable-line
    widgetConfig: any; // eslint-disable-line
    state: Router;
    openWizard: any; // eslint-disable-line
    subscription: Subscription;
    changeDetectorRef: ChangeDetectorRef;
    closeWizardObj: Subscription;
    activatedRouteSubscription: Subscription;
    wizardService: LdapConfigWizardService;

    constructor(
        state: Router,
        changeDetectorRef: ChangeDetectorRef,
        wizardService: LdapConfigWizardService,
        private readonly activatedRoute: ActivatedRoute,
        private readonly factoryResolver: ComponentFactoryResolver
    ) {
        super();
        this.state = state;
        this.changeDetectorRef = changeDetectorRef;
        this.wizardService = wizardService;
    }

    ngOnInit() {
        this.activatedRouteSubscription = this.activatedRoute.queryParams.subscribe(data => {
            const defaultParams = merge({}, JSON.parse(get(data, 'defaultParams', '{}')));
            this.wizardService.editMode = this.wizardId === 'update_ldap_server';
            this.wizardService.openWizard(this.wizardId, this.wizardConfig, defaultParams);
        });
    }

    ngAfterViewInit() {
        this.createContentComponent();
        this.changeDetectorRef.detectChanges();
    }

    ngOnDestroy() {
        if (this.closeWizardObj) {
            this.closeWizardObj.unsubscribe();
        }
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.activatedRouteSubscription) {
            this.activatedRouteSubscription.unsubscribe();
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
    get(object: any, path: string): any {
        return get(object, path);
    }

    //-------------- Control && Validation -----------------------
    toggleNext(): void {
        this.wizardService.nextStep();
        this.createContentComponent();
    }

    toggleBack(): void {
        this.wizardService.previousStep();
        this.createContentComponent();
    }

    toggleFinish(): void {
        const result = (this.wizardService as LdapConfigWizardService).onFinish();
        result.subscribe(() => {
            this.createContentComponent();
        });
    }

    toggleClose(): void {
        this.wizardService.toggleClose(() => this.onClose.emit(true));
    }

    toggleReOpen(): void {
        this.wizardService.reOpen();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any,,@typescript-eslint/explicit-module-boundary-types
    notifyOnToggleSubContent(onOff: any): void {
        if (onOff) {
            this.createSubContentComponent();
        } else {
            this.subContentRef.clear();
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getWizardService(): any {
        return this.wizardService;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getFactoryResolver(): any {
        return this.factoryResolver;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getContentViewRef(): any {
        return this.contentRef;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getSubContentViewRef(): any {
        return this.subContentRef;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolveComponentType(pageId: string): any {
        switch (pageId) {
            case 'ldap.server.configuration.component.html':
                return LdapServerConfigurationComponent;
            case 'ldap.servers.results.component.html':
                return LdapServerResultComponent;
            default: {
                console.error('Unrecognized template name:', pageId);
                return null;
            }
        }
    }
}